export default "__VITE_ASSET__DPMB0XqE__"